import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { showErrorToast } from "#app/notifications";
import { updateUser } from "#modules/users/infra/updateUser.api";

type Option = {
  onSuccess?: () => void;
};

export const useUpdateUser = (options?: Option) => {
  const { mutate, ...rest } = useMutation({
    mutationFn: updateUser,
    onSuccess: () => {
      options?.onSuccess?.();
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        showErrorToast({
          title: "Une erreur est survenue",
          message: error.response?.data.message,
        });
      }
    },
  });

  return { updateUser: mutate, ...rest };
};
